import React, {useEffect} from "react";
import {useSelector} from "react-redux";
import { gaDataLayer } from "../../utils";
import {certificationPage, extractKeywordFromUrl } from "../../utils/registrationUtils";
import { domainValue } from "../../constants/dashboard";
import Cookies from "universal-cookie";

function DataLayerEvents (props) {
  const { user: _user } = useSelector((state) => state.userData);
    const cookies = new Cookies();
    const subDomainName = window.location.host?.split(".")[0];
    const urlCheck = window.location.href;
    let certificationFormCheck = window.location.search?.includes("ftype=certificationform") ||
    window.location.search?.includes("ftype=certification") || certificationPage(urlCheck);
    const currentUrl = document.referrer ? document.referrer : cookies?.get(`${subDomainName}-${certificationFormCheck}-rgData`)?.source_destination;
    const urlObj = currentUrl ? new URL(currentUrl) : null;
    const cleanUrl = urlObj ? `${urlObj.origin}${urlObj.pathname}` : null;
    let launguageCheck =  (window.location.href?.includes("/hi/") || subDomainName == "hindinews") ? "HI" : "EN";
    const keywordMatch = extractKeywordFromUrl(cleanUrl);
    let domainData = keywordMatch ? domainValue?.filter((obj) => keywordMatch === obj.domain) : domainValue?.filter((obj) => subDomainName === obj.domain);
    let domainId = certificationFormCheck ? "23" : domainData?.[0]?.value ? domainData?.[0]?.value : "18";

    useEffect(() => {
   const timeout = setTimeout(() => {
          if (_user) {
            let data = [
              props.contentType,
              props.pageTypes,
              domainId,
              props.verticalName,
              "",
              "",
              "",
              "",
              "",
              "Yes",
              _user?.data?.id,
              "No",
              launguageCheck,
              "",
              "",
            ];
            gaDataLayer(...data);
          }else {
            let data = [
                props.contentType,
                props.pageTypes,
                domainId,
                props.verticalName,
                "",
                "",
                "",
                "",
                "",
                "No",
                "",
                "No",
                launguageCheck,
                "",
                "",
              ];
              gaDataLayer(...data);
          }
        }, 1000);
        return () => clearTimeout(timeout);
      }, [_user]);

    return<></>
}
export default DataLayerEvents;